import { Routes } from '@angular/router'
import { ssoAttemptGuard } from './guards/sso-attempt.guard'
import { VerifyPhoneGuard } from './guards/verify-phone.guard'
import { LaunchGuard } from './guards/launch.guard'
import { BYPASS_LAUNCH_DATA } from './guards/launch-bypass'
import { AuthGuard } from './guards/auth.guard'
import { QrCodeGuard } from './guards/qr-code.guard'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'launch?next=/map',
  },
  {
    path: 'launch',
    loadComponent: () =>
      import('./pages/launch/launch.page').then((m) => m.LaunchPage),
  },

  {
    path: '',
    canActivateChild: [LaunchGuard],
    children: [
      {
        path: 'map',
        loadComponent: () =>
          import('./pages/map/map.page').then((m) => m.MapPage),
      },
      {
        path: 'confirm-code',
        loadComponent: () =>
          import(
            './pages/auth/reset-password/confirm-code/confirm-code.page'
          ).then((m) => m.ConfirmCodePage),
      },
      {
        path: 'enter-phone',
        loadComponent: () =>
          import(
            './pages/auth/reset-password/enter-phone/enter-phone.page'
          ).then((m) => m.EnterPhonePage),
      },
      {
        path: 'landing',
        loadComponent: () =>
          import('./pages/landing/landing.page').then((m) => m.LandingPage),
        canActivate: [AuthGuard],
      },
      {
        path: 'payment-method',
        loadComponent: () =>
          import('./pages/auth/payment-method/payment-method.page').then(
            (m) => m.PaymentMethodPage
          ),
      },
      {
        path: 'supporting-documents',
        loadComponent: () =>
          import('./pages/supporting-documents/supporting-documents.page').then(
            (m) => m.SupportingDocumentsPage
          ),
      },
      {
        path: 'signin',
        loadComponent: () =>
          import('./pages/auth/signin/signin.page').then((m) => m.SigninPage),
        canActivate: [AuthGuard],
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./pages/auth/signup/signup.page').then((m) => m.SignupPage),
        canActivate: [AuthGuard],
      },
      {
        path: 'signup-minified',
        loadComponent: () =>
          import('./pages/auth/signup-minified/signup-minified.page').then(
            (m) => m.SignupMinifiedPage
          ),
        data: { [BYPASS_LAUNCH_DATA]: true },
        canActivate: [ssoAttemptGuard],
      },
      {
        path: 'identity-link',
        loadComponent: () =>
          import('./pages/auth/identity-link/identity-link.page').then(
            (m) => m.IdentityLinkPage
          ),
      },
      {
        path: 'external-auth-failed',
        loadComponent: () =>
          import(
            './pages/auth/external-auth-failed/external-auth-failed.page'
          ).then((m) => m.ExternalAuthFailedPage),
        canActivate: [ssoAttemptGuard],
      },
      {
        path: 'verify-phone',
        loadComponent: () =>
          import('./pages/auth/verify-phone/verify-phone.page').then(
            (m) => m.VerifyPhonePage
          ),
        canActivate: [VerifyPhoneGuard],
      },

      {
        path: 'search-page',
        loadComponent: () =>
          import('./pages/search/search.page').then((m) => m.SearchPage),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./pages/account/menu/menu.page').then((m) => m.MenuPage),
      },
      {
        path: 'account/abonnements',
        loadComponent: () =>
          import('./pages/account/abonnements/abonnements.page').then(
            (m) => m.AbonnementsPage
          ),
      },
      {
        path: 'account/trips',
        loadComponent: () =>
          import('./pages/account/trips/trips.page').then((m) => m.TripsPage),
      },
      {
        path: 'account/bookings',
        loadComponent: () =>
          import('./pages/account/bookings/bookings.page').then(
            (m) => m.BookingsPage
          ),
      },
      {
        path: 'account/settings',
        loadComponent: () =>
          import('./pages/account/settings/settings.page').then(
            (m) => m.SettingsPage
          ),
      },
      {
        path: 'account/invoices',
        loadComponent: () =>
          import('./pages/account/invoices/invoices.page').then(
            (m) => m.InvoicesPage
          ),
      },
      {
        path: 'account/wallet',
        loadComponent: () =>
          import('./pages/account/wallet/wallet.page').then(
            (m) => m.WalletPage
          ),
      },
      {
        path: 'account/nfc',
        loadComponent: () =>
          import('./pages/account/nfc/nfc.page').then((m) => m.NfcPage),
      },
      {
        path: 'account/privacy',
        loadComponent: () =>
          import('./pages/account/privacy/privacy.page').then(
            (m) => m.PrivacyPage
          ),
        data: { [BYPASS_LAUNCH_DATA]: true },
      },
      {
        path: 'account/cookies',
        loadComponent: () =>
          import('./pages/account/cookies/cookies.page').then(
            (m) => m.CookiesPage
          ),
      },
      {
        path: 'account/payment-methods',
        loadComponent: () =>
          import('./pages/account/payment-methods/payment-methods.page').then(
            (m) => m.PaymentMethodsPage
          ),
      },
      {
        path: 'account/settings/cgu',
        loadComponent: () =>
          import('./pages/account/cgu/cgu.page').then((m) => m.CguPage),
        data: { [BYPASS_LAUNCH_DATA]: true },
      },
      {
        path: 'account/settings/infos',
        loadComponent: () =>
          import('./pages/account/infos/infos.page').then((m) => m.InfosPage),
      },
      {
        path: 'abo-congrats',
        loadComponent: () =>
          import('./pages/congrats/abonnements/abo-congrats.page').then(
            (m) => m.AboCongratsPage
          ),
      },
      {
        path: 'trips/congrats',
        loadComponent: () =>
          import('./pages/congrats/trips/trips-congrats.page').then(
            (m) => m.TripsCongratsPage
          ),
      },
      {
        path: 'cgu-congrats',
        loadComponent: () =>
          import('./pages/congrats/cgu-congrats/cgu-congrats.page').then(
            (m) => m.CguCongratsPage
          ),
      },
      {
        path: 'report-congrats',
        loadComponent: () =>
          import('./pages/congrats/report/report-congrats.page').then(
            (m) => m.ReportCongratsPage
          ),
      },
      {
        path: 'recommandation-congrats',
        loadComponent: () =>
          import('./pages/congrats/recommandation/recommandation.page').then(
            (m) => m.RecommandationPage
          ),
      },
      {
        path: 'account/support',
        loadComponent: () =>
          import('./pages/account/support/support.page').then(
            (m) => m.SupportPage
          ),
      },
      {
        path: 'account/change-password',
        loadComponent: () =>
          import('./pages/account/change-password/change-password.page').then(
            (m) => m.ChangePasswordPage
          ),
      },
      {
        path: 'kyc',
        loadComponent: () =>
          import('./pages/kyc/kyc.page').then((m) => m.KYCPage),
      },
      {
        path: 'booking/create/details',
        loadComponent: () =>
          import(
            './pages/booking/booking-form-details/booking-form-details.page'
          ).then((m) => m.BookingFormDetailsPage),
      },
      {
        path: 'booking/create',
        loadComponent: () =>
          import('./pages/booking/booking-form/booking-form.page').then(
            (m) => m.BookingFormPage
          ),
      },
      {
        path: 'renting/qr-code',
        loadComponent: () =>
          import('./pages/renting/qr-code/qr-code.page').then(
            (m) => m.QrCodePage
          ),
        data: { [BYPASS_LAUNCH_DATA]: true },
        canActivate: [QrCodeGuard],
      },
    ],
  },
  {
    path: 'renting',
    loadComponent: () =>
      import('./pages/renting/bike-number/bike-number.page').then(
        (m) => m.BikeNumberPage
      ),
  },
  {
    path: '**',
    redirectTo: '/launch',
  },
]
